const routes = [
  {
    path: "/",
    name: "welcome",
    component: () => import("../views/landing/Home.vue"),
    meta: {
      title: "seo.welcome.title",
      metaTags: [
        {
          name: "description",
          content: "seo.welcome.metaTags.description",
        },
        {
          property: "og:description",
          content: "seo.welcome.metaTags.description",
        },
      ],
    },
  },
  {
    path: "/privacy",
    name: "privacy",
    component: () => import("../views/general/Privacy.vue"),
    meta: {
      title: "seo.privacy.title",
    },
  },
  {
    path: "/data-deletion",
    name: "data-deletion",
    component: () => import("../views/general/DataDeletion.vue"),
  },
  {
    path: "/terms",
    name: "terms",
    component: () => import("../views/general/Terms.vue"),
    meta: {
      title: "seo.terms.title",
    },
  },
  {
    path: "/invitation",
    name: "invitation",
    component: () => import("../views/invitation/EmployeeInvitation.vue"),
    meta: {
      title: "Invitation",
    },
  },
  {
    path: "/very-secret-login-link",
    name: "login-2",
    component: () => import("../views/auth/Login.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/auth/Login.vue"),
    meta: {
      title: "Sign in",
    },
  },

  {
    path: "/register",
    name: "register",
    component: () => import("../views/auth/Register.vue"),
    meta: {
      title: "Register",
    },
  },
  {
    path: "/password/forgot",
    name: "forgot-password",
    component: () => import("../views/auth/ForgotPassword.vue"),
    meta: {
      title: "Refresh Password",
    },
  },
  {
    path: "/password/reset",
    name: "reset-password",
    component: () => import("../views/auth/ResetPassword.vue"),
    meta: {
      title: "Refresh Password",
    },
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("../views/Contact.vue"),
    meta: {
      title: "Contact",
    },
  },
  {
    path: "/home",
    name: "home",
    component: () =>
      import(/* webpackChunkName: "authenticated" */ "../views/authenticated/UserDashboard.vue"),
    meta: {
      title: "My account",
    },
  },
  {
    path: "/add-entity",
    name: "add-entity",
    component: () =>
      import(/* webpackChunkName: "authenticated" */ "../views/authenticated/AddEntity.vue"),
    meta: {
      title: "Add new business",
    },
  },
  {
    path: "*",
    name: "not-found",
    component: () => import("../views/error"),
    meta: {
      title: "This page could not be found.",
    },
  },
];

export const getRouteByName = function(name) {
  return routes.find(route => route.name === name);
};

export default routes;
